module.exports = __webpack_public_path__ + "static/img/pharmaceuticalEnterprises4.bacac0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Parters/pharmaceuticalEnterprises4.png
// module id = YN2/
// module chunks = 1